import { useState, useEffect } from "react";

const useCamera = () => {
    const [cameraStream, setCameraStream] = useState(null);
    const [cameraPermission, setCameraPermission] = useState('prompt'); // 'granted', 'denied', 'prompt'
    const [facingMode, setFacingMode] = useState('user'); // 'user' for front, 'environment' for back

    const requestCameraAccess = async (facing = 'user') => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: facing,
                    width: { ideal: 1280 },
                    height: { ideal: 720 }
                },
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    autoGainControl: true
                }
            });

            // Verify audio tracks are present
            const audioTracks = stream.getAudioTracks();
            audioTracks.forEach(track => {
            });

            setCameraStream(stream);
            setCameraPermission('granted');
            setFacingMode(facing);
            return stream;
        } catch (error) {
            console.error('Camera access denied:', error);
            setCameraPermission('denied');
            return null;
        }
    };

    const stopCameraStream = () => {
        if (cameraStream) {
            cameraStream.getTracks().forEach(track => track.stop());
            setCameraStream(null);
        }
    };

    const switchCamera = async () => {
        try {
            // Stop current stream
            if (cameraStream) {
                cameraStream.getTracks().forEach(track => track.stop());
            }

            // Toggle facing mode
            const newFacingMode = facingMode === 'user' ? 'environment' : 'user';

            // Request new stream with switched camera
            const newStream = await requestCameraAccess(newFacingMode);

            return newStream;
        } catch (error) {
            console.error('Error switching camera:', error);
            // If switching fails, try to restore the original camera
            await requestCameraAccess(facingMode);
            throw error;
        }
    };

    // Initialize camera on first mount and cleanup on unmount
    useEffect(() => {
        requestCameraAccess();

        return () => {
            // Cleanup: stop all camera tracks when component unmounts
            stopCameraStream();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        cameraStream,
        cameraPermission,
        facingMode,
        requestCameraAccess,
        stopCameraStream,
        switchCamera
    };
};

export default useCamera;